export const at2x = (at1x) => at1x.replace("@1x", "@2x");

export const srcset = (at1x) => `${at1x} 1x, ${at2x(at1x)} 2x`;
